import { ReactWidget, type Message } from '@theia/core/lib/browser';
import { injectable, postConstruct } from '@theia/core/shared/inversify';
import type { ComponentType } from 'react';

@injectable()
export class ProjectOverview extends ReactWidget {
    static readonly ID = 'widget:lvgl-project-overview';
    static readonly LABEL = 'Project Overview';

    private component: ComponentType | undefined;
    private loadError: string | undefined;

    @postConstruct()
    protected init(): void {
        this.id = ProjectOverview.ID;
        this.title.label = ProjectOverview.LABEL;
        this.title.caption = ProjectOverview.LABEL;
        this.title.closable = false;
        this.title.iconClass = 'codicon codicon-home';
        this.doInit();
    }

    protected async doInit(): Promise<void> {
        try {
            const mod = await import('@lved/ui/components/shared/ui/ProjectOverview');
            this.component = (mod as unknown as { default: ComponentType }).default;
        } catch (error: unknown) {
            this.loadError = error instanceof Error ? error.message : 'Failed to load Project Overview.';
        }
        this.update();
    }

    protected override onActivateRequest(msg: Message): void {
        super.onActivateRequest(msg);
        void this.clearCurrentTabPath();
    }

    protected async clearCurrentTabPath(): Promise<void> {
        const fileStoreModule: typeof import('@lved/ui/store/fileStore') = await import('@lved/ui/store/fileStore');
        const { currentTabPath, setCurrentTabPath } = fileStoreModule.useFileStore.getState();
        if (currentTabPath !== '') setCurrentTabPath('');
    }

    protected render(): JSX.Element {
        if (this.loadError) {
            return <p style={{ padding: '8px', color: 'var(--theia-errorForeground)' }}>{this.loadError}</p>;
        }
        if (!this.component) {
            return <p style={{ padding: '8px' }}>Loading…</p>;
        }
        const Component = this.component;
        return <Component />;
    }
}
